import React from 'react'
import { connect } from 'react-redux'
import { login } from '../../store/actions'
import { authController } from '../../apiService'
import { Section } from '../../components'
import { ResendStyled } from './styled'
import { ROUTE_PATH } from 'helpers'
import { toast } from 'react-toastify'
import { withRouter } from 'react-router-dom'

class ResendContainer extends React.Component {
  constructor(props) {
    super(props)
    if (!this.props.location.state) {
      props.history.push(ROUTE_PATH.LOGIN.LINK)
    }
  }

  _submitResent() {
    authController().activateEmail(this.props.location.state.email)
    toast('Please check your email', {
      position: 'top-center',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      type: 'success',
    })
  }

  render() {
    return (
      <React.Fragment>
        <ResendStyled className="activate-page">
          <Section className="activate-wrapper">
            <Section className="notification">
              <p>
                Your account has not been activated, please activate your
                account.
                <br />
                If you don&apos;t receive your activation email, click{' '}
                <a
                  href="#"
                  //onClick={() => this._submitResent}
                  onClick={
                    () => {
                      this._submitResent()
                    }
                    // console.log('eeeeeeeeeeeeeeeeeeee'))
                  }
                >
                  here
                </a>
                &nbsp;to resend.
              </p>
            </Section>
          </Section>
        </ResendStyled>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    login: state.login,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actionLogin: payload => dispatch(login(payload)),
  }
}

export const ResendEmailContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ResendContainer))
